module.exports = __webpack_public_path__ + "static/media/trump-johnson-trudeau-subjectivity.3164e25e.png";